import { render, staticRenderFns } from "./clinical.vue?vue&type=template&id=4652757f&scoped=true"
import script from "./clinical.vue?vue&type=script&lang=js"
export * from "./clinical.vue?vue&type=script&lang=js"
import style0 from "./clinical.vue?vue&type=style&index=0&id=4652757f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4652757f",
  null
  
)

export default component.exports